package com.tixforgigs.common.core.util


import com.tixforgigs.common.core.util.StorageUtil.getStorageItem
import com.tixforgigs.common.core.util.StorageUtil.setStorageItem
import kotlinx.serialization.builtins.serializer
import kotlin.uuid.Uuid

internal actual fun getPlatformUniqueId(): Uuid {
  return getStorageItem<String>(StorageUtil.StorageKey.UniqueId)?.let {
    runCatching { Uuid.parse(it) }.getOrNull()
  } ?: Uuid.random().also {
    setStorageItem(StorageUtil.StorageKey.UniqueId, it.toString(), String.serializer())
  }
}

internal actual suspend fun getDeviceId(): String {
  return getPlatformUniqueId().toString()
}
